/* =====================================================================
   AFS mount product page — gallery + description accordions.
   The buy panel (colour, cutouts, live size, cart) is driven separately
   by the tested afs-configurator.js custom element.
   ===================================================================== */
(function () {
  function initGallery() {
    const thumbs = document.getElementById('afsThumbs');
    const stage = document.getElementById('afsStage');
    if (!thumbs || !stage) return;
    const buttons = [...thumbs.querySelectorAll('.afs-thumb')];
    if (!buttons.length) return;
    let current = 0;
    const show = (i) => {
      current = (i + buttons.length) % buttons.length;
      const btn = buttons[current];
      const full = btn.dataset.full;
      if (full) stage.src = full;
      const alt = btn.querySelector('img')?.alt;
      if (alt) stage.alt = alt;
      buttons.forEach((b, idx) => b.classList.toggle('is-current', idx === current));
    };
    buttons.forEach((b, idx) => b.addEventListener('click', () => show(idx)));
    document.getElementById('afsPrev')?.addEventListener('click', () => show(current - 1));
    document.getElementById('afsNext')?.addEventListener('click', () => show(current + 1));
    const scrollThumbs = (direction) => {
      const horizontal = window.matchMedia('(max-width: 520px)').matches;
      thumbs.scrollBy(horizontal ? { left: direction * 240, behavior: 'smooth' } : { top: direction * 240, behavior: 'smooth' });
    };
    document.getElementById('afsThumbPrev')?.addEventListener('click', () => scrollThumbs(-1));
    document.getElementById('afsThumbNext')?.addEventListener('click', () => scrollThumbs(1));

    // Preload the full-size images on idle so switching between them is instant.
    const preloadFull = () => {
      buttons.forEach((b) => {
        const src = b.dataset.full;
        if (!src) return;
        const img = new Image();
        img.decoding = 'async';
        img.src = src;
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(preloadFull, { timeout: 2500 });
    else setTimeout(preloadFull, 500);
  }

  function initAccordions() {
    const source = document.querySelector('[data-afs-description]');
    const target = document.getElementById('afsAcc');
    if (!source || !target) return;

    const productTitle = (target.dataset.productTitle || '').trim().toLowerCase();
    const sections = [];
    let current = null;

    source.childNodes.forEach((node) => {
      const isHeading = node.nodeType === 1 && node.tagName === 'H3';
      if (isHeading) {
        current = { title: node.textContent.trim(), body: [] };
        sections.push(current);
      } else {
        if (!current) { current = { title: 'Overview', body: [] }; sections.push(current); }
        current.body.push(node.cloneNode(true));
      }
    });

    // First section heading is usually the product name — relabel to "Overview"
    if (sections.length && sections[0].title.trim().toLowerCase() === productTitle) {
      sections[0].title = 'Overview';
    }

    const usable = sections.filter((s) => s.title && s.body.some((n) => (n.textContent || '').trim() || n.querySelector));
    if (!usable.length) return;

    target.innerHTML = '';
    usable.forEach((section, index) => {
      const details = document.createElement('details');
      if (index === 0) details.open = true;

      const summary = document.createElement('summary');
      summary.append(section.title);
      const plus = document.createElement('span');
      plus.className = 'afs-plus';
      summary.append(plus);
      details.append(summary);

      const body = document.createElement('div');
      body.className = 'afs-acc__body';
      section.body.forEach((node) => body.append(node));
      details.append(body);

      target.append(details);
    });
  }

  function init() { initGallery(); initAccordions(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();